import React, { useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setTableData } from './store/dataSlice'
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'
import Tooltip from 'components/Ui/Tooltip'
import { ConfirmationModal, Table } from 'components/Ui'
import { deleteApiRecord } from 'services/RolesService'
import { Success } from 'utils/alerts'
import useAuth from 'utils/hooks/useAuth'
// import { activeStatus } from 'components/helper'
// import dayjs from 'dayjs'
injectReducer('roles', reducer)

export default function Roles() {
    const dispatch = useDispatch()
    const { checkPermission } = useAuth()
    const { data, tableData, loading } = useSelector(state => state.roles.data)

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
    ])

    const fetchData = () => dispatch(getData({ ...tableData }))

    const handleDelete = id => {
        deleteApiRecord(id)
            .then(() => {
                Success('Deleted Successfully!')
                fetchData()
            })
            .catch(error => console.log('Error: ', error))
    }

    // const handleStatus = (id, data) => {
    //     delete data.image
    //     updateApiRecord(id, data)
    //         .then(() => {
    //             Success('Status Updated Successfully!')
    //             fetchData()
    //         })
    //         .catch(error => console.log('Error: ', error))
    // }

    const columns = useMemo(
        () => [
            {
                field: 'name',
                header: 'Role',
                className: 'min-w-[150px]',
                hide: false,
            },
            // {
            //     field: 'status',
            //     header: 'Status',
            //     hide: false,
            //     renderCell: row => {
            //         return checkPermission('company', 'status') ? (
            //             <ConfirmationModal
            //                 onConfirm={() => {
            //                     handleStatus(row.id, { ...row, is_active: !row.is_active })
            //                 }}
            //             >
            //                 {activeStatus(row.is_active)}
            //             </ConfirmationModal>
            //         ) : (
            //             activeStatus(row.is_active)
            //         )
            //     },
            // },
            {
                field: 'action',
                header: 'Action',
                className: 'px-4',
                hide: false,
                renderCell: row => {
                    return (
                        <div className="flex items-center gap-3">
                            {checkPermission('roles', 'edit') ? (
                                <Tooltip title={'Edit'}>
                                    <Link to={`/company-management/roles/${row.id}/edit`} className="hover:text-primary">
                                        <HiOutlinePencil size={20} />
                                    </Link>
                                </Tooltip>
                            ) : null}
                            {checkPermission('roles', 'delete') ? (
                                <Tooltip title={'Delete'}>
                                    <ConfirmationModal
                                        message={'Are you sure you want to delete this record!'}
                                        onConfirm={() => {
                                            handleDelete(row.id)
                                        }}
                                    >
                                        <span className="hover:text-danger">
                                            <HiOutlineTrash size={20} />
                                        </span>
                                    </ConfirmationModal>
                                </Tooltip>
                            ) : null}
                        </div>
                    )
                },
            },
        ],
        // eslint-disable-next-line
        [tableData.sort, tableData.query, tableData.pageIndex, tableData.pageSize, tableData.selectedTab, tableData.checkBox]
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Roles</h2>
            </div>
            <Table
                loading={loading}
                filter={false}
                datas={data}
                columns={columns}
                add_new={checkPermission('roles', 'create') ? '/company-management/roles/create' : ''}
                pagingData={tableData}
                onChange={e => dispatch(setTableData(e))}
            />
        </>
    )
}
